import { useCallback, useEffect, useMemo, useState } from 'react';
export function useMarkerSelection({ markers }) {
    const [selectedSlug, setSelectedSlug] = useState(undefined);
    useEffect(() => {
        if (selectedSlug && !markers.some((marker) => marker.parkingSlug === selectedSlug)) {
            setSelectedSlug(undefined);
        }
    }, [markers, selectedSlug]);
    const allMarkers = useMemo(() => markers.map((marker) => ({
        ...marker,
        isSelected: marker.parkingSlug === selectedSlug,
    })), [markers, selectedSlug]);
    const selectMarker = useCallback((parkingSlug) => {
        setSelectedSlug(parkingSlug);
    }, []);
    return {
        allMarkers,
        selectMarker,
    };
}
